{
  "fr": {
    "table": {
      "cells": {
        "storageLocation": {
          "personal": "Mon espace de stockage"
        }
      },
      "columns": {
        "access": "Accès",
        "author": "Auteur",
        "created": "Créé le",
        "date": "Date",
        "deletion": "Supprimé le",
        "invitedBy": "Invitation de",
        "joinedAt": "Rejoint le",
        "name": "Nom",
        "projects": "Projets",
        "school": "École",
        "select": "Sélection",
        "selectAll": "Tout sélectionner",
        "status": "Statut",
        "progress": "Progression",
        "feedback": "Feedback",
        "updatedAt": "Modifié le",
        "updated_at": "Modifié le",
        "folder": "Dossier",
        "storageLocation": "Emplacement de stockage",
        "source": "Source",
        "responses": "Réponses",
        "responsesCount": "Nombre de soumissions",
        "drafts": "Brouillons",
        "preCorrections": "Pré-corrections",
        "title": "Titre",
        "archivedAt": "Archivé le",
        "description": "Description",
        "projectsCount": "Projets"
      },
      "author": {
        "currentUser": "Je"
      },
      "emptyState": {
        "noContent": "Aucun contenu trouvé",
        "noSearchResults": "Aucun résultat pour cette recherche."
      }
    }
  }
}
